import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { legacy_createStore as createStore } from 'redux';
import reducer from './js/reducers';
import App from './App';
import './index.scss';
import { loadState, saveState } from './js/hooks/persistRedux';
import reportWebVitals from './reportWebVitals';
const initialState = loadState();

const store = createStore(
  reducer,
  initialState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

store.subscribe(() => {
  saveState(store.getState());
});

const container = document.getElementById('react-app');
if (container) {
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
} else {
  console.error("Target container 'react-app' not found in the DOM.");
}
reportWebVitals();